import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Menu from "../main/Menu";
import { axiosClient } from "../../helpers/axios";
import Header from "../main/Header";
import { useSelector } from "react-redux";

const MiddlewareAuth = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.Login.auth);
  const token = '';

  // Configurar interceptor una sola vez (idealmente en setup global)
  useEffect(() => {
    const interceptor = axiosClient.interceptors.request.use(
      (config) => {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        if (error.response?.status === 401) {
          // Aquí podrías limpiar sesión si lo deseas
        }
        return Promise.reject(error);
      }
    );

    // Simulamos carga inicial (puedes poner validaciones aquí)
    setTimeout(() => {
      setLoading(false);
    }, 500); // Puedes ajustar la duración

    // Cleanup interceptor
    return () => {
      axiosClient.interceptors.request.eject(interceptor);
    };
  }, []);

  if (loading) {
    return (
      <div className="w-screen h-screen flex items-center justify-center bg-fr-light">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-fr-primary border-solid"></div>
      </div>
    );
  }

  if (user && user.isAuth) {
    return (
      <>
        <Header />
        <div className="flex flex-row max-h-screen">
          <Menu />
          <div className="w-full h-screen overflow-auto bg-fr-secondary">
            {children}
          </div>
        </div>
      </>
    );
  } else {
    return <Navigate to="/login" />;
  }
};

export default MiddlewareAuth;
